import { webKnots } from '../../../../common/back/lace/webKnots'
import { webToCatchFaceConnect } from '../lace/webToCatchFaceConnect'
import { middleSidePartOfWeb, topSidePartOfWeb, topSidePartOfWebWithJoint } from './parts/sideParts'

export const hWebWithEdge = (ctx: CanvasRenderingContext2D, webColor: string, edgeColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(627, 117) //左上
  ctx.quadraticCurveTo(607, 176, 571, 220) //左下
  ctx.quadraticCurveTo(591, 240, 607, 280) //右下
  ctx.quadraticCurveTo(658, 233, 672, 184) //右上
  ctx.quadraticCurveTo(650, 141, 627, 115) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ヘリ革パーツ
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(627, 115) //左上
  ctx.quadraticCurveTo(607, 176, 571, 220) //左下
  ctx.quadraticCurveTo(577, 227, 577, 227) //右下
  ctx.quadraticCurveTo(614, 183, 634, 124) //右上
  ctx.quadraticCurveTo(627, 117, 627, 115) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.moveTo(667, 172) //左上
  ctx.quadraticCurveTo(645, 235, 603, 269) //左下
  ctx.quadraticCurveTo(607, 280, 607, 280) //右下
  ctx.quadraticCurveTo(658, 233, 672, 184) //右上
  ctx.quadraticCurveTo(667, 172, 667, 172) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // // 縦向き＿左
  ctx.moveTo(636, 125) // 上
  ctx.quadraticCurveTo(617, 185, 580, 228) // 下
  // // 縦向き＿右
  ctx.moveTo(664, 172) // 上
  ctx.quadraticCurveTo(647, 227, 603, 265) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  webToCatchFaceConnect(ctx, laceColor, 0, 30, 0.95)
  webKnots(ctx, laceColor, 25, -54) // ウェブ先端寄りのウェブ結び目
  webKnots(ctx, laceColor, -20, 20) // 捕球面寄りのウェブ結び目
}

export const hJointWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // 横上パーツ
  topSidePartOfWebWithJoint(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -17, 18, 1, 1)
  // 縦パーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(610, 160) //左上
  ctx.quadraticCurveTo(607, 176, 563, 226) //左下
  ctx.quadraticCurveTo(585, 250, 599, 283) //右下
  ctx.quadraticCurveTo(633, 254, 648, 225) //右上
  ctx.quadraticCurveTo(635, 186, 610, 160) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // // 縦向き＿左＿外側
  ctx.moveTo(612, 167) // 上
  ctx.quadraticCurveTo(601, 194, 576, 220) // 下
  // // // 縦向き＿左＿内側
  ctx.moveTo(614, 170) // 上
  ctx.quadraticCurveTo(605, 195, 580, 222) // 下
  // // // 縦向き＿右＿内側
  ctx.moveTo(642, 220) // 上
  ctx.quadraticCurveTo(629, 247, 606, 269) // 下
  // // // 縦向き＿右＿外側
  ctx.moveTo(644, 224) // 上
  ctx.quadraticCurveTo(633, 249, 608, 273) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  webToCatchFaceConnect(ctx, laceColor, -35, 15)
  webKnots(ctx, laceColor, 5, -15) // ウェブ先端寄りのウェブ結び目
  webKnots(ctx, laceColor, -30, 30) // 捕球面寄りのウェブ結び目
}
